import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useContext } from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { FlexibleUiContext } from '../../../../../state/flexible-ui-context';
import { MediaType } from '../../../../../constants';
import Media from '../media';
const Preview = props => {
  const {
    overrideUrl,
    ...rest
  } = props !== null && props !== void 0 ? props : {};
  const context = useContext(FlexibleUiContext);
  const data = overrideUrl ? {
    url: overrideUrl,
    type: MediaType.Image
  } : context === null || context === void 0 ? void 0 : context.preview;
  if (!data) {
    return null;
  }
  return jsx(Media, _extends({}, rest, data));
};
export default Preview;